module.exports = __webpack_public_path__ + "static/media/lato-light.5e8e5fde.woff";